import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';

export default class SgCustomerPreferenceService {
    static getCustomerPreferenceDetails(customPreferenceDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gdprService'),
            'retrieveCpcDetails',
            [customPreferenceDTO],
            additionalHeaders
        );
    }

    static saveCustomerPreferenceDetails(customPreferenceDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gdprService'),
            'storeCpcDetails',
            [customPreferenceDTO],
            additionalHeaders
        );
    }

    static getCpcOnlineRefData(additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gdprService'),
            'getCpcOnlineRefData',
            [],
            additionalHeaders
        );
    }

    static getCustomerPermissionDetails(customPreferenceDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gdprService'),
            'retrieveCustomerPermissionDetails',
            [customPreferenceDTO],
            additionalHeaders
        );
    }

    static saveCustomerPermissionDetails(customPreferenceDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gdprService'),
            'saveCustomerPermissionDetails',
            [customPreferenceDTO],
            additionalHeaders
        );
    }
}
